import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "ylp_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const submitContact = async (payload) => {
  const { data } = await axios.post(`${API}/contact`, payload, {
    headers: { "Content-Type": "application/json" },
  });
  return data;
};

export const submitEmailLead = async (email, source = "email_popup") => {
  const { data } = await axios.post(
    `${API}/lead`,
    { email, source },
    { headers: { "Content-Type": "application/json" } }
  );
  return data;
};

export const adminLogin = async (email, password) => {
  const { data } = await axios.post(`${API}/admin/login`, { email, password });
  setToken(data.token);
  return data;
};

export const adminMe = async () => {
  const { data } = await axios.get(`${API}/admin/me`, { headers: authHeaders() });
  return data;
};

export const adminContacts = async () => {
  const { data } = await axios.get(`${API}/admin/contacts`, { headers: authHeaders() });
  return data;
};

export const adminEmailLeads = async () => {
  const { data } = await axios.get(`${API}/admin/leads`, { headers: authHeaders() });
  return data;
};

export const adminExportUrl = () => `${API}/admin/export/contacts.csv`;
